import carchallanimage from "../assets/images/pcn/a-red-light-traffic.png";
import { FilterItem } from "./appeal-process-tabledata-mock";

//Table Data Interface
export interface ColumnData {
 
  id: number;
  pcnNumer: string;
  vehicleNumber: string;
  offence: string;
  issueDate: string;
  time: string;
  amount: string;
  status: string;
  carchallanimage:{}[];
}
// row data
export interface TableHeader {
  name: string;
  sortdata: string;
  algntext: any;
  sortIcon:boolean
}
//FilterInterface
export interface filterInterFace {
  vehiclenumberfilter: string,
  timeFrame: string,
}
//filterstateInterFace 
export interface filterstateInterFace {
  vehicleNumber: string,
  timeFrame: string,
  startDate?: any,
  endDate?: any,
} //Dialogtitleprops interface
export interface DialogTitleProps {
  id: string;
  children?: React.ReactNode;
  onClose: () => void;
}
//TabPanelProps interface
export interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}
//Form Data
export const groundReasonChallengeList = [
  { challengeType: "I was not the owner of the vehicle at the time of the alleged contravention" },
  { challengeType: "The  alleged contravention does not occour" },
  { challengeType: "The PCN increase the amount in these circumstances of the case  " },
  { challengeType: "The relevant designation order was invalid " },
  { challengeType: "There has been a procedural on behalf of the authority " },
  { challengeType: "Others" },
]
export const pcnCouncil = [
  { council: "London Councils" },
  { council: "Westminister City Council" },
  { council: "County Councils Network" },
  { council: "Hammersmith and Fulham Council" },
  { council: "Wandsworth London Borough Council" },
  { council: "Southwark Council" },
  { council: "Islington Council" },
  { council: "Hackney Council" },
  { council: "Waltham Forest Council" },
  { council: "Haringey Council" },
  { council: "Barnet Council" },
  { council: "Queens Park Community Council" },
  { council: "Newham Council" },
]

export const pcnList = [
  {vehicleNumber :"KY70 CWT"},
  {vehicleNumber :"HZ13 HDD"},
  {vehicleNumber :"RK05 YFT"},
  {vehicleNumber :"LO93 YRS"},
  {vehicleNumber :"HZ13 HZZ"},
  {vehicleNumber :"HZ13 HTT"},
  {vehicleNumber :"HZ13 HAA"},
]

export const formOffenceTypes = [
  { offenceType: "Bus lane contraventions"},
  { offenceType: "Moving contravention"},
  { offenceType: "On street contravention"},
  { offenceType: "Static contravention"},
];
export const offenceDescription=[
	{
		Code: "01",
		Description: "Parked in a restricted street during prescribed hours"
	},
	{
		Code: "02",
		Description: "Parked or loading / unloading in a restricted street where waiting and loading / unloading restrictions are in force"
	},
	{
		Code: "04",
		Description: "Parked in a meter bay when penalty time is indicated"
	},
	{
		Code: "05",
		Description: "Parked after the expiry of paid for time"
	},
	{
		Code: "06",
		Description: "Parked without clearly displaying a valid pay & display ticket or voucher"
	},
	{
		Code: "07",
		Description: "Parked with payment made to extend the stay beyond initial time"
	},
	{
		Code: "08",
		Description: "Parked at an out-of-order meter during controlled hours"
	},
	{
		Code: "09",
		Description: "Parked displaying multiple pay & display tickets where prohibited"
	},
	{
		Code: "10",
		Description: "Parked without clearly displaying two valid pay and display tickets when required"
	},
	{
		Code: "11",
		Description: "Parked without payment of the parking charge"
	},
	{
		Code: "12",
		Description: "Parked in a residents’ or shared use parking place or zone without a valid virtual permit or clearly displaying a valid physical permit or voucher or pay and display ticket issued for that place where required, or without payment of the parking charge"
	},
	{
		Code: "13",
		Description: "'- - - - RESERVED FOR TfL USE (LOW EMISSION ZONE) - - - -"
	},
	{
		Code: "14",
		Description: "Parked in an electric vehicles’ charging place during restricted hours without charging"
	},
	{
		Code: "16",
		Description: "Parked in a permit space or zone without a valid virtual permit or clearly displaying a valid physical permit where required"
	},
	{
		Code: "17",
		Description: "- - - - RESERVED FOR ROAD USER CHARGING USE - - - -"
	},
	{
		Code: "18",
		Description: "Using a vehicle in a parking place in connection with the sale or offering or exposing for sale of goods when prohibited"
	},
	{
		Code: "19",
		Description: "Parked in a residents' or shared use parking place or zone with an invalid virtual permit or displaying an invalid physical permit or voucher or pay and display ticket, or after the expiry of paid for time"
	},
	{
		Code: "20",
		Description: "Parked in a part of a parking place marked by a yellow line where waiting is prohibited"
	},
	{
		Code: "21",
		Description: "Parked wholly or partly in a suspended bay or space"
	},
	{
		Code: "22",
		Description: "Re-parked in the same parking place or zone within one hour after leaving"
	},
	{
		Code: "23",
		Description: "Parked in a parking place or area not designated for that class of vehicle"
	},
	{
		Code: "24",
		Description: "Not parked correctly within the markings of the bay or space"
	},
	{
		Code: "25",
		Description: "Parked in a loading place or bay during restricted hours without loading"
	},
	{
		Code: "26",
		Description: "Parked in a special enforcement area more than 50 cm from the edge of the carriageway and not within a designated parking place"
	},
	{
		Code: "27",
		Description: "Parked in a special enforcement area adjacent to a footway, cycle track or verge lowered to meet the level of the carriageway"
	},
	{
		Code: "28",
		Description: "Parked in a special enforcement area on part of the carriageway raised to meet the level of a footway, cycle track or verge"
	},
	{
		Code: "29",
		Description: "Failing to comply with a one-way restriction"
	},
	{
		Code: "30",
		Description: "Parked for longer than permitted"
	},
	{
		Code: "31",
		Description: "Entering and stopping in a box junction when prohibited"
	},
	{
		Code: "32",
		Description: "Failing to proceed in the direction shown by the arrow on a blue sign"
	},
	{
		Code: "33",
		Description: "Using a route restricted to certain vehicles"
	},
	{
		Code: "34",
		Description: "Being in a bus lane"
	},
	{
		Code: "35",
		Description: "Parked in a disc parking place without clearly displaying a valid disc"
	},
	{
		Code: "36",
		Description: "Being in a mandatory cycle lane"
	},
	{
		Code: "37",
		Description: "Failing to give way to oncoming vehicles"
	},
	{
		Code: "38",
		Description: "Failing to comply with a sign indicating that vehicular traffic must pass to the specified side of the sign"
	},
	{
		Code: "39",
		Description: "'- - - - RESERVED FOR TfL USE (ULTRA LOW EMISSION ZONE) - - - -"
	},
	{
		Code: "40",
		Description: "Parked in a designated disabled person’s parking place without displaying a valid disabled person’s badge in the prescribed manner"
	},
	{
		Code: "41",
		Description: "Stopped in a parking place designated for diplomatic vehicles"
	},
	{
		Code: "42",
		Description: "Parked in a parking place designated for police vehicles"
	},
	{
		Code: "43",
		Description: "Stopped on a cycle docking station parking place"
	},
	{
		Code: "45",
		Description: "Stopped on a taxi rank"
	},
	{
		Code: "46",
		Description: "Stopped where prohibited (on a red route or clearway)"
	},
	{
		Code: "47",
		Description: "Stopped on a restricted bus stop or stand"
	},
	{
		Code: "48",
		Description: "Stopped in a restricted area outside a school, a hospital or a fire, police or ambulance station when prohibited"
	},
	{
		Code: "49",
		Description: "Parked wholly or partly on a cycle track or lane"
	},
	{
		Code: "50",
		Description: "Performing a prohibited turn"
	},
	{
		Code: "51",
		Description: "Failing to comply with a no entry restriction"
	},
	{
		Code: "52",
		Description: "Failing to comply with a prohibition on certain types of vehicle"
	},
	{
		Code: "53",
		Description: "Failing to comply with a restriction on vehicles entering a pedestrian zone"
	},
	{
		Code: "54",
		Description: "Failing to comply with a restriction on vehicles entering and waiting in a pedestrian zone"
	},
	{
		Code: "55",
		Description: "A commercial vehicle parked in a restricted street in contravention of the Overnight Waiting Ban"
	},
	{
		Code: "56",
		Description: "Parked in contravention of a commercial vehicle waiting restriction"
	},
	{
		Code: "57",
		Description: "Parked in contravention of a bus ban"
	},
	{
		Code: "58",
		Description: "Using a vehicle on a restricted street during prescribed hours without a valid permit"
	},
	{
		Code: "59",
		Description: "Using a vehicle on a restricted street during prescribed hours in breach of permit conditions"
	},
	{
		Code: "61",
		Description: "A heavy commercial vehicle wholly or partly parked on a footway, verge or land between two carriageways"
	},
	{
		Code: "62",
		Description: "Parked with one or more wheels on or over a footpath or any part of a road other than a carriageway"
	},
	{
		Code: "63",
		Description: "Parked with engine running where prohibited"
	},
	{
		Code: "64",
		Description: "Parked in contravention of a notice prohibiting leaving vehicles on a grass verge, garden, lawn or green maintained by a local authority"
	},
	{
		Code: "65",
		Description: "Parked in contravention of a notice prohibiting leaving vehicles on land laid out as a public garden or used for the purpose of public recreation"
	},
	{
		Code: "66",
		Description: "Parked on a verge, central reservation or footway comprised in an urban road"
	},
	{
		Code: "67",
		Description: "Using a vehicle on a restricted street without a valid HGV Safety Permit"
	},
	{
		Code: "68",
		Description: "Using a vehicle on a restricted street in breach of HGV Safety Permit conditions"
	},
	{
		Code: "72",
		Description: "- - - RESERVED FOR BUILDERS’ SKIPS CONTRAVENTIONS - - -"
	},
	{
		Code: "75",
		Description: "- - - RESERVED FOR LITTERING FROM MOTOR VEHICLES - - -"
	},
	{
		Code: "76",
		Description: "- - RESERVED FOR WASTE RECEPTACLE CONTRAVENTIONS - -"
	},
	{
		Code: "99",
		Description: "Stopped on a pedestrian crossing or crossing area marked by zigzags"
	}
]
// table header data
export const rows: ColumnData[] = [
  {
    id: 1,
    pcnNumer: "SQ12098643",
    vehicleNumber: "HZ13 WDD",
    offence: "Over Speeding",
    issueDate: "08/02/2022",
    time: "18:20",
    amount: "35.00",
    status: "New",
    carchallanimage:[{image:carchallanimage} ,{image:carchallanimage},{image:carchallanimage}]
  },
  {
    id: 2,
    pcnNumer: "FK19037258",
    vehicleNumber: "KY70 CWT",
    offence: "Park in Bus Lane",
    issueDate: "8/5/2022",
    time: "18:20",
    amount: "35.00",
    status: "Paid",
    carchallanimage:[{image:carchallanimage} ,{image:carchallanimage},{image:carchallanimage}]
  },
  {
    id: 3,
    pcnNumer: "SW56091331",
    vehicleNumber: "HZ13 WDD",
    offence: "Parked after the expiry of paid for time",
    issueDate: "6/19/2022",
    time: "18:20",
    amount: "35.00",
    status: "Appeal in process",
    carchallanimage:[{image:carchallanimage} ,{image:carchallanimage},{image:carchallanimage}]
  },
  {
    id: 4,
    pcnNumer: "GV00911246",
    vehicleNumber: "BF91 CBR",
    offence: "Parked on a taxi rank",
    issueDate: "7/30/2022",
    time: "18:20",
    amount: "35.00",
    status: "Appeal rejected",
    carchallanimage:[{image:carchallanimage} ,{image:carchallanimage},{image:carchallanimage}]
  },
  {
    id: 5,
    pcnNumer: "RC16920787",
    vehicleNumber: "GZ26 FRS",
    offence: "Over Speeding",
    issueDate: "02/06/2021",
    time: "18:20",
    amount: "35.00",
    status: "Appeal accepted",
    carchallanimage:[{image:carchallanimage} ,{image:carchallanimage},{image:carchallanimage}]
  },
  {
    id: 6,
    pcnNumer: "TY56790813",
    vehicleNumber: "KY70 CWT",
    offence: "Parked on a taxi rank",
    issueDate: "06/26/2022",
    time: "18:20",
    amount: "35.00",
    status: "Paid",
    carchallanimage:[{image:carchallanimage} ,{image:carchallanimage},{image:carchallanimage}]
  },
  {
    id: 7,
    pcnNumer: "SQ12098643",
    vehicleNumber: "HZ13 WDD",
    offence: "Park in Bus Lane",
    issueDate: "08/02/2022",
    time: "18:20",
    amount: "35.00",
    status: "Appeal accepted",
    carchallanimage:[{image:carchallanimage} ,{image:carchallanimage},{image:carchallanimage}]
  },
  {
    id: 8,
    pcnNumer: "SQ12098643",
    vehicleNumber: "HZ13 WDD",
    offence: "Park in Bus Lane",
    issueDate: "08/02/2022",
    time: "18:20",
    amount: "35.00",
    status: "Appeal in process",
    carchallanimage:[{image:carchallanimage} ,{image:carchallanimage},{image:carchallanimage}]
  },
  {
    id: 9,
    pcnNumer: "SQ12098643",
    vehicleNumber: "HZ13 WDD",
    offence: "Over Speeding",
    issueDate: "08/02/2022",
    time: "18:20",
    amount: "35.00",
    status: "Appeal rejected",
    carchallanimage:[{image:carchallanimage} ,{image:carchallanimage},{image:carchallanimage}]
  },
  {
    id: 10,
    pcnNumer: "SQ12098643",
    vehicleNumber: "HZ13 WDD",
    offence: "Over Speeding",
    issueDate: "08/02/2022",
    time: "18:20",
    amount: "35.00",
    status: "Paid",
    carchallanimage:[{image:carchallanimage} ,{image:carchallanimage},{image:carchallanimage}]
  },
  {
    id: 11,
    pcnNumer: "SQ12098643",
    vehicleNumber: "HZ13 WDD",
    offence: "Over Speeding",
    issueDate: "08/02/2022",
    time: "18:20",
    amount: "35.00",
    status: "New",
    carchallanimage:[{image:carchallanimage} ,{image:carchallanimage},{image:carchallanimage}]
  },
  {
    id: 12,
    pcnNumer: "SQ12098643",
    vehicleNumber: "HZ13 WDD",
    offence: "Over Speeding",
    issueDate: "08/02/2022",
    time: "18:20",
    amount: "35.00",
    status: "New",
    carchallanimage:[{image:carchallanimage} ,{image:carchallanimage},{image:carchallanimage}]
  },
  {
    id: 13,
    pcnNumer: "SQ12098643",
    vehicleNumber: "HZ13 WDD",
    offence: "Over Speeding",
    issueDate: "08/02/2022",
    time: "18:20",
    amount: "35.00",
    status: "New",
    carchallanimage:[{image:carchallanimage} ,{image:carchallanimage},{image:carchallanimage}]
  },
  {
    id: 14,
    pcnNumer: "SQ12098643",
    vehicleNumber: "HZ13 WDD",
    offence: "Over Speeding",
    issueDate: "08/02/2022",
    time: "18:20",
    amount: "35.00",
    status: "New",
    carchallanimage:[{image:carchallanimage} ,{image:carchallanimage},{image:carchallanimage}]
  },
  {
    id: 15,
    pcnNumer: "SQ12098643",
    vehicleNumber: "HZ13 WDD",
    offence: "Over Speeding",
    issueDate: "08/02/2022",
    time: "18:20",
    amount: "35.00",
    status: "New",
    carchallanimage:[{image:carchallanimage} ,{image:carchallanimage},{image:carchallanimage}]
  },
  {
    id: 16,
    pcnNumer: "SQ12098643",
    vehicleNumber: "HZ13 WDD",
    offence: "Over Speeding",
    issueDate: "08/02/2022",
    time: "18:20",
    amount: "35.00",
    status: "New",
    carchallanimage:[{image:carchallanimage} ,{image:carchallanimage},{image:carchallanimage}]
  },
  {
    id: 17,
    pcnNumer: "SQ12098643",
    vehicleNumber: "HZ13 WDD",
    offence: "Over Speeding",
    issueDate: "08/02/2022",
    time: "18:20",
    amount: "35.00",
    status: "New",
    carchallanimage:[{image:carchallanimage} ,{image:carchallanimage},{image:carchallanimage}]
  },
  {
    id: 18,
    pcnNumer: "SQ12098643",
    vehicleNumber: "HZ13 WDD",
    offence: "Over Speeding",
    issueDate: "08/02/2022",
    time: "18:20",
    amount: '35.00',
    status: "New",
    carchallanimage:[{image:carchallanimage} ,{image:carchallanimage},{image:carchallanimage}]


  },
  {
    id: 19,
    pcnNumer: "SQ12098643",
    vehicleNumber: "HZ13 WDD",
    offence: "Over Speeding",
    issueDate: "08/02/2022",
    time: "18:20",
    amount: "35.00",
    status: "New",
    carchallanimage:[{image:carchallanimage} ,{image:carchallanimage},{image:carchallanimage}]
  },
  {
    id: 20,
    pcnNumer: "SQ12098643",
    vehicleNumber: "HZ13 WDD",
    offence: "Over Speeding",
    issueDate: "02/08/2022",
    time: "18:20",
    amount: "35.00",
    status: "New",
    carchallanimage:[{image:carchallanimage} ,{image:carchallanimage},{image:carchallanimage}]


  },
  {
    id: 21,
    pcnNumer: "SQ12098643",
    vehicleNumber: "HZ13 WDD",
    offence: "Over Speeding",
    issueDate: "20/09/2022",
    time: "18:20",
    amount: "35.00",
    status: "New",
    carchallanimage:[{image:carchallanimage} ,{image:carchallanimage},{image:carchallanimage}]

  },

];
// modal data
export const modalData = [
  { modalDataDescription: "GF76 JHG", id: 1 },
  { modalDataDescription: "Parking in bus lane", id: 2 },
  { modalDataDescription: "52JM Failing to comply ", id: 3 },
  { modalDataDescription: "Hawtrey Avenue ", id: 4 },
  { modalDataDescription: "London Borough of Ealing", id: 5 },
];

export const timeFrames: FilterItem = {
  selectorLabel:"Time Frame",
  filtterData:[
  { inputValue: "Today", inputOption: "Today" },
  { inputValue: "Last Week", inputOption: "Last week" },
  { inputValue: "This Month", inputOption: "This month" },
  { inputValue: "Last Month", inputOption: "Last month" },
  { inputValue: "Year To Date", inputOption: "Year to date" },
  { inputValue: "Last Year", inputOption: "Last Year" },
  { inputValue: "Date Range", inputOption: "Date range" },
  ]
};

// vehicle number filter data
export const vehiclenumberfilter = [
  { vehicleNumber: "KY70 CWT" },
  { vehicleNumber: "HZ13 HDD" },
  { vehicleNumber: "RK05 TYT" },
  { vehicleNumber: "LO93 YRS" },
];
// modal detail data
export const modalDataDetails = [
  { details: "Vehicle Number:", id: 1 },
  { details: "Offence Type", id: 2 },
  { details: "Offence Code", id: 3 },
  { details: "Location", id: 4 },
  { details: "Council", id: 5 },
];
// payments
export const payment = [
  { item: "Invoice No:", id: 1 },
  { item: "Invoice Date:", id: 2 },
  { item: "Payment Type:", id: 3 },
  { item: "Net Amount:", id: 4 },
  { item: "Vehicle Number:", id: 5 },
  { item: "Name:", id: 6 },
  { item: "Service Type:", id: 7 },
];
// payments summary
export const paymentSummary = [
  { item: "JG84273343", id: 1 },
  { item: "6/22/2022", id: 2 },
  { item: "Credit Card", id: 3 },
  { item: "£ 20.00", id: 4 },
  { item: "KJ87 HGF", id: 5 },
  { item: "Zoe Viccajji", id: 6 },
  { item: "Parking", id: 7 },
];

export const tableHeader: TableHeader[] = [
  { name: "No", sortdata: "id", algntext: "",sortIcon:false },
  { name: " PCN Number", sortdata: "appealNumber", algntext: "",sortIcon:false },
  { name: "Vehicle Number", sortdata: "vehicleNumber", algntext: "",sortIcon:true },
  { name: "Offence", sortdata: "offenceType", algntext: "",sortIcon:true },
  { name: "Issued Date", sortdata: "createdAt", algntext: "",sortIcon:false },
  { name: "Contravention Time", sortdata: "time", algntext: "",sortIcon:false },
  { name: "Amount", sortdata: "amount", algntext: "",sortIcon:false },
  // { name: "Status", sortdata: "status", algntext: "left" }
];

export const amount = [
  { balanceamount: "£25.00", id: 1 },
  { balanceamount: "£25.00", id: 2 },
];
export const amountRemaining = [
  { amount: "Available Amount ", id: 1 },
  { amount: "Due Amount ", id: 2 },
];
export const dueamount = [
  { amount: "Due Amount ", id: 1, balanceamount: "£25.00" },
];
export interface Date {
  date: string;
}
export interface Data {
  data: string;
}
export const filterdata = [
  { filtervehicle: "Vehicle Number", id: 1 },
  { filtertime: "Time Frame", id: 2 },
];
export const circulardeterminate = [{ circulardata: "Days", id: 1 }, { circulardata: "Hrs", id: 2 }, { circulardata: "Min", id: 3 }, { circulardata: "Sec", id: 4 }]

export const appealInfo = [
  { appeal: "Appeal Date:" },
  { appeal: "Appeal Type" },
  { appeal: "Appeal Reason" },
];

export const appealInfoData = [
  { appealdata: "01/11/2021" },
  { appealdata: "Informal" },
  { appealdata: "Parked after the expiry of paid for time" },
];

export const norInfo = [
  { nor: "Notice Date:" },
  { nor: "Rejection Code:" },
  { nor: "Evidence is not valid" },
];
export const norInfoData = [
  { nordata: "01/11/2021" },
  { nordata: "090078" },
  { nordata: "Evidence is not valid" },
];

export const noteInfoData={day:"28" ,amount:"75.00"}

